module.exports = __webpack_public_path__ + "img/c6b2f9f6ccb7dd1f4e899293a07cebc8.png";